import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../../store/StoreManager';
import properties from '../../../constants/Properties';
import { setShortcutsTarget } from '../../../actions/CurrentSlideActions';
import { ScrollableComponent } from '../../menus/ScrollableComponent';
import mouseUtils from '../../../components/utils/MouseUtils';
import { AudioEditorTimeline } from '../../audioEditor/menus/AudioEditorTimeline';
import { Ruler } from '../../audioEditor/menus/Ruler';
import playController from '../../utils/PlayController';
import audioToolUtils from '../utils/AudioToolUtils';
import platformDetection from '../../utils/PlatformDetection';

const TimelinesContent = React.createClass({
    getInitialState() {
        return {
            elements: []
        };
    },
    componentDidMount() {
        this.initElements();
    },
    componentWillReceiveProps(nextProps) {
        if (this.props.zoomValue != nextProps.zoomValue || this.props.accordionWidth != nextProps.accordionWidth || this.props.timelineWidth != nextProps.timelineWidth || this.props.windowHeight != nextProps.windowHeight) {
            if (this.props.accordionWidth != nextProps.accordionWidth)
                this.recreateElements(false);
            else {
                if (this.props.timelineWidth != nextProps.timelineWidth)
                    this.recreateElements(true, true);
                else
                    this.recreateElements(true);
            }
        }
    },
    recreateElements(updateScroll = true, useOldScrollPosition = false) {
        setTimeout(this.refreshNewContent, 50, updateScroll, useOldScrollPosition);
    },
    refreshNewContent(updateScroll = true, useOldScrollPosition = false) {
        this.initElements(updateScroll, useOldScrollPosition);
    },
    initElements(updateScroll, useOldScrollPosition = false) {
        var totalWidth = this.props.timelineWidth;

        const holderStyle = {
            position: 'absolute',
            left: 0,
            top: 0,
            width: totalWidth
        };

        var holder = <div style={holderStyle} key={'audioEditor'}>
            <Ruler buttonsHolderWidth={this.props.buttonsHolderWidth} width={totalWidth} zoomValue={this.props.zoomValue} dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth}/>
            <AudioEditorTimeline buttonsHolderWidth={this.props.buttonsHolderWidth} width={totalWidth} zoomValue={this.props.zoomValue} dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} windowHeight={this.props.windowHeight}/>
        </div>;

        var elements = [holder];

        this.setState({
            elements
        });

        if (updateScroll && !platformDetection.isIOS()) {
            playController.updateScrollPosition(300, true);
        }
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (!storeManager.getState().currentSlide.isSlideCommand)
            this.props.dispatch(setShortcutsTarget(true));
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.elements != nextState.elements || this.props.accordionWidth != newProps.accordionWidth || this.props.refreshAudioTrack != newProps.refreshAudioTrack || this.props.windowWidth != newProps.windowWidth || this.props.zoomValue != newProps.zoomValue || this.props.timelineWidth != newProps.timelineWidth || this.props.listHeight != newProps.listHeight)
            return true;
        else
            return false;
    },
    render() {
        if (this.state == undefined || this.state.elements == undefined)
            return (<div/>);

        const listWidth = this.props.windowWidth - this.props.accordionWidth - audioToolUtils.buttonsHolderWidth();

        const listStyle = {
            width: listWidth,
            height: this.props.listHeight,
            position: 'absolute',
            overflowY: 'hidden',
            overflowX: 'hidden',
            left: audioToolUtils.buttonsHolderWidth(),
            top: properties.SLIDE_VIEWER_TOP_LINE_HEIGHT,
            cursor: 'default',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            WebkitTouchCallout: 'none',
            userDrag: 'none'
        };

        var componentProperties = {};

        componentProperties.paddingTop = properties.SLIDE_VIEWER_TOP_GAP;
        componentProperties.paddingLeft = 0;
        componentProperties.width = listWidth;
        componentProperties.height = this.props.listHeight;
        componentProperties.top = 0;
        componentProperties.displayState = 'block';
        componentProperties.isHorizontal = true;
        componentProperties.elements = this.state.elements;
        componentProperties.id = 'slidesList';
        componentProperties.isAudioEditor = true;
        componentProperties.scrollWidth = this.props.timelineWidth;

        if (componentProperties.scrollWidth > componentProperties.width)
            componentProperties.scrollWidth = componentProperties.scrollWidth + 2;

        return (
            <div style={listStyle} onClick={this.onClick}>
                <ScrollableComponent componentProperties={componentProperties}/>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    var accordionWidth = state.accordion.width;
    const uuid = Math.random();
    var zoomValue = state.audioEditor.zoomValue;
    var timelineWidth = state.audioEditor.timelineWidth;
    const refreshAudioTrack = state.audioEditor.refreshAudioTrack;

    if (zoomValue == undefined)
        zoomValue = 4;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    return {
        accordionWidth,
        uuid,
        zoomValue,
        timelineWidth,
        refreshAudioTrack
    };
}

export const Timelines = connect(mapStateToProps)(TimelinesContent);



/** WEBPACK FOOTER **
 ** ./src/components/audioTool/menus/Timelines.js
 **/